/** @jsx dom */
import deepEqual from 'deep-equal';
import dom from 'magic-virtual-element';
import {privateFields, companyFields} from '~/utils/form-fields';
import Field from './field';

const propTypes = {
	getTranslation: {
		source: 'getTranslation'
	},
	openPopup: {
		source: 'openPopup'
	},
	site: {
		source: 'site'
	},
	validationError: {
		source: 'validationError'
	}
};

const renderFields = props => {
	const getFields = props.customer.person_flg ? privateFields : companyFields;
	const fields = getFields(props.customer, props);

	return Object.entries(fields).map(([key, field]) => {
		const {label, value = '', type = 'text', required, rules} = field;

		return (
			<Field
				rules={rules}
				type={type}
				name={key}
				label={label}
				value={value}
				required={required}
			/>
		);
	});
};

const shouldUpdate = ({props, state}, nextProps) => deepEqual(props, nextProps);

const render = ({props}) => (
	<div class='VcoCustomer'>
		{renderFields(props)}
	</div>
);

export default {propTypes, render, shouldUpdate};
